import BrandCard from "./BrandCard";
export default BrandCard;
